import { render } from "./NewStory.vue?vue&type=template&id=5030e460"
import script from "./NewStory.vue?vue&type=script&lang=js"
export * from "./NewStory.vue?vue&type=script&lang=js"

import "./NewStory.vue?vue&type=style&index=0&id=5030e460&lang=css"

import exportComponent from "D:\\javascript\\storyticket-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__